import { Property } from '~/common/types/buildings';

export const getPropertyDisplayName = ({ name, address }: Property) =>
  name?.trim() || address.split(',')[0].trim();

export const getPropertyValidity = (
  { isResidential, tenureType, occupiedStatus }: Property,
  noResidentsFound?: boolean,
) => {
  // Check value explicitly as a workaround for outdated datasets
  if (isResidential === false) {
    return { isValid: false, reason: 'non-residential' };
  }

  if (tenureType === 'LEASEHOLD') {
    return { isValid: false, reason: 'leasehold' };
  }

  if (occupiedStatus === 'VOID' || noResidentsFound) {
    return { isValid: false, reason: 'void' };
  }

  return { isValid: true };
};
